<template>
    <div class="sellerList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>销售业绩榜单</el-breadcrumb-item>
            <el-breadcrumb-item>直客销售榜单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button class="edit-btn-common" v-show="!disabled" @click="cancelEdit()" size="small">{{"取消编辑"}}</el-button>
        <el-button class="edit-btn-common edit-btn" @click="clickEdit()" size="small" type="primary">{{disabled?"编辑":"完成编辑"}}</el-button>
        <el-table v-for="(item,parentIndex) in sellerList" :key="parentIndex" class="project-list-table" :data="item" stripe border>
            <el-table-column label="全国" align='center' width="60px">
                <template scope="scope">
                    <span>{{scope.row===null?'':scope.row[propertyNameList[0]]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="区域" align='center' width="100px">
                <template scope="scope">
                    <span>{{scope.row===null?'':(scope.row[propertyNameList[1]]+'---'+scope.row[propertyNameList[4]])||''}}</span>
                </template>
            </el-table-column>
            <el-table-column label="姓名" align='center' width="80px">
                <template scope="scope">
                    <span>{{scope.row===null?'':scope.row[propertyNameList[2]]||''}}</span>
                </template>
            </el-table-column>
            <el-table-column label="业绩" align='center'  width="80px">
                <template scope="scope">
                    <span>{{scope.row===null?'':scope.row[propertyNameList[3]]||''}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <el-button size="small" :disabled="disabled" type="info" @click="openLink(parentIndex,scope.$index)">编辑</el-button>
                    <el-button size="small" :disabled="disabled" :type="scope.row===null?'':'success'" @click="deleteProject(parentIndex,scope.$index)">{{scope.row===null?'恢复':'下移'}}</el-button>
                    <el-button size="small" :disabled="disabled" type="danger" @click="realDelete(parentIndex,scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--编辑弹框-->
        <el-dialog v-if="editForm" title="编辑" v-model="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
            <el-form :model="editForm" ref="editForm" label-width="100px">
                <el-form-item label="全国排名" prop="editName">
                    <el-input v-model="editForm[propertyNameList[0]]" auto-complete="off" placeholder="请输入销售人员姓名"></el-input>
                </el-form-item>
                <el-form-item label="区域" prop="editNum">
                    <el-input v-model="editForm[propertyNameList[1]]" auto-complete="off" placeholder="请输入完成率"></el-input>
                </el-form-item>
                <el-form-item label="销售姓名" prop="editName">
                    <el-input v-model="editForm[propertyNameList[2]]" auto-complete="off" placeholder="请输入销售人员姓名"></el-input>
                </el-form-item>
                <el-form-item :label="propertyNameList[3]" prop="editName">
                    <el-input v-model="editForm[propertyNameList[3]]" auto-complete="off" placeholder="请输入销售人员姓名"></el-input>
                </el-form-item>
                <el-form-item label="区域排名" prop="editName">
                    <el-input v-model="editForm[propertyNameList[4]]" auto-complete="off" placeholder="请输入销售人员姓名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSubmit('editForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "sellerList",
    data() {
        return {
            allData: null,
            sellerList: null,
            sellerListString:'',
            propertyNameList: ['全国排名','区域','销售','达成率','区域排名'],
            dialogFormVisible: false,
            editForm: null,
            editIndex: -1,
            partName: 'zhike-selling',
            disabled:true
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        _getName(sellerList){
            for(let i=0;i<this.sellerList.length;i++){
                var item = this.sellerList[i];
                for(let j=0;j<item.length;j++){
                    if(item[j]){
                        let keys = Object.keys(item[j]);
                        for(let k=0;k<keys.length;k++){
                            if(/达成率/.test(keys[k])){
                                return keys[k];
                            }
                        }
                    }
                }
            }
            return "业绩";
        },
        _getProjectList() {
            let self = this;
            this.$http.get(CONFIG.HOST + "/salesList/getSalesList" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    var o = TOOL.formatObj(result.data);
                    this.allData = o;
                    this.sellerList = o[self.partName];
                    this.sellerListString = JSON.stringify(this.sellerList);
                    this.propertyNameList[3] =  self._getName(this.sellerList);
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        openLink(parentIndex,index){
            try{
                var tmp = JSON.stringify(this.sellerList[parentIndex][index]);
                this.editForm = JSON.parse(tmp);
            }catch(e){
                this.editForm = {};
            }
            if(!this.editForm){this.editForm = {};}
            this.dialogFormVisible = true;
            this.editIndex = [parentIndex,index];
        },
        cancelEdit(){
            this.sellerList = JSON.parse(this.sellerListString);
            this.disabled = true;
        },
        editSubmit(formName){
            // this.$set(this.sellerList[this.editIndex[0]],this.editIndex[1],this.editForm);
            this.sellerList[this.editIndex[0]].splice(this.editIndex[1],1,this.editForm);
            this.dialogFormVisible = false;
            // var tmp = JSON.stringify(this.editForm),
            //     self = this;
            // self.$set(this.sellerList,this.editIndex, JSON.parse(tmp));
            // self.dialogFormVisible = false;
            // self.updateData({
            //   key: self.partName,
            //   value: JSON.stringify(self.sellerList)
            // }, ()=>{
            //   self._getProjectList();
            // });
        },
        clickEdit(){
            if(this.disabled){
                this.disabled = false;
            }else{
                this.disabled = true;
                let value = JSON.stringify(this.sellerList);
                if(this.sellerListString==value){
                    return;
                }
                this.updateData({
                    key: this.partName,
                    value: value
                }, ()=>{
                    this._getProjectList();
                    });
                }
        },
        realDelete(parentIndex,index){
            this.sellerList[parentIndex][index]=null;
            this.deleteProject(parentIndex,index);
        },
        deleteProject(parentIndex,index) {
            let sellerList = this.sellerList;
            let tmpValue = sellerList[parentIndex][index];
            if(tmpValue==null){
                sellerList[parentIndex].splice(index,1);
                let newData = null;
                for(let i=parentIndex;i<sellerList.length-1;i++){
                    newData = sellerList[i+1].shift();
                    sellerList[i].push(newData);
                }
                let flag = sellerList[sellerList.length-1].every((item)=>item==null);
                if(flag){
                    sellerList.pop();
                }else{
                    sellerList[sellerList.length-1].push(null);
                }
            }else{
                sellerList[parentIndex].splice(index,0,null);
                let newData = sellerList[parentIndex].pop();
                for(let i=parentIndex+1;i<sellerList.length;i++){
                    sellerList[i].unshift(newData);
                    newData = sellerList[i].pop();
                }
                if(newData!=null){
                    var a = [newData,null,null,null,null,null,];
                    sellerList.push(a);
                }
            }
            // let self =this;
            // this.sellerList.splice(projectId);
            // 修改本地数据
            // this.allData[self.partName] = JSON.stringify(this.sellerList);
            // ------end------
            // 向服务器同步数据
            // self.updateData({
            //   key: self.partName,
            //   value: JSON.stringify(self.sellerList)
            // }, ()=>{
            //   self._getProjectList();
            // });
            // ------end------
        },
        updateData(data, callback){
          this.$http.put(CONFIG.HOST + "/salesList/updateSale", data).then((response)=>{
              let result = response.body;
              if (result && result.status === 1) {
                  callback();
              } else {
                  this.$notify.error({
                      message: result.message
                  });
              }
          }, (response)=>{
              console.log(response);
          });
        },
        _init() {
            this._getProjectList();
        }
    }
};
</script>
<style lang="less">
    .sellerList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        // .project-list-table{
        //     min-width: 980px;
        // }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }
    .project-list-table{
        font-size: 0.7rem;
        min-width: 480px;
        width: 43%;
        margin-bottom:30px; 
        float: left;
        margin-left: 0;
    }
    .project-list-table:nth-of-type(2n){
        margin-right: 20px;
    }
    .edit-btn{
        z-index: 10000;
        margin-right: 70%;
    }
    .edit-btn-common{
        float: left;
        margin-left: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// ZhikeSeller.vue?0e0bf737